import { createTheme,ThemeProvider} from '@mui/material/styles';
import Button from '@mui/material/Button';
import styled from "styled-components";
import * as FaIcons from "react-icons/fa";
import Tooltip from '@mui/material/Tooltip';

const LatestEpochButtonDiv = styled.div`
  position:absolute;
  cursor:default;
  display:flex;
  justify-content: flex-end;
  margin-top:14px;
  min-width:200px;
  padding-right:20px;
  margin-right:1px;
  right:0;
  padding-left:0px;
  z-index:2;    
`;

const TextDisplayStyle = styled.div`
    display:flex;
    justify-content: space-between;
    flex:1;
    align-content: center;
    font-size: 0.8em;
    font-family:Helvetica,sans-serif;
    border-radius:3px;
    height:30px;
    box-shadow: rgba(0,0,0,0.1) 0px 0px 1px 1px, rgba(0, 0, 0, 0.1) 0px 0px 0px 0px;
    &:hover {
        box-shadow: rgba(0, 0, 0, 0.25) 0px 1px 2px, rgba(0, 0, 0, 0.05) 0px 0px 0px;
    }
    padding-right:14px;
    padding-top:1px;
`
const EpochValueDisplayStyle= styled.p`
    display:flex;
    justify-content: flex-start;
    align-content: center;
    flex:1;
    color:#1d4d99;
    font-size: 1em;
    font-family:Helvetica,sans-serif;
    padding-right:2px;
    margin-left:10px;
    margin-top:7px;
`
const grayTheme = createTheme({
    palette: {
        primary: {
        light: '#757ce8',
        main: '#f3f3f3',
        dark: '#d4d4d4',
        contrastText: '#000',
        },
        secondary: {
        light: '#ff7961',
        main: '#f44336',
        dark: '#ba000d',
        contrastText: '#000',
        },
    },
    });

export const PlotSectionDiv = styled.div`
    position:relative;
    margin-top: 10px;
    margin-right:10px;
    justify-content:end;
    flex:${(props) => props.flexRatio};
    max-width:100%;
    height:90vh;
    overflow:scroll;
    background-color: ${(props) => props.color};
    box-shadow: rgba(50, 50, 93, 0.25) 0px 6px 6px -2px, rgba(0, 0, 0, 0.3) 0px 3px 3px -3px;
    &:hover {
        box-shadow: rgba(0, 0, 0, 0.25) 0px 4px 2px, rgba(0, 0, 0, 0.05) 0px 0px 0px;
    }
`;

// box-shadow: rgba(50, 50, 93, 0.25) 0px 6px 6px -2px, rgba(0, 0, 0, 0.3) 0px 3px 3px -3px;
//     &:hover {
//         box-shadow: rgba(0, 0, 0, 0.25) 0px 14px 28px, rgba(0, 0, 0, 0.05) 0px 10px 10px;
//     }

export const EpochDataBlock=({selectedEpoch,handleLatestEpochButton,lastUpdatedTime})=>{
    const RightButton = ()=>{
        return(
        <ThemeProvider theme={grayTheme}>
                    <Button style={{fontSize:'0.8em',height:'28px',minWidth: '20px', borderRadius:'0px',maxWidth: '30px',paddingRight:2,paddingLeft:2,paddingTop:2,paddingBottom:2}}
                        sx={{boxShadow:'0px 0px 1px rgba(0, 0, 0, 0.25)',
                            '&:hover': {
                                boxShadow: '0px 0px 1px rgba(0, 0, 0, 0.35)', // Shadow on hover
                                }
                        }} 
                        variant="contained" color="primary" title="Get Latest Epoch" data-placement 
                        onClick={handleLatestEpochButton}><FaIcons.FaSync style={{color:"#595959"}}/></Button>    
        </ThemeProvider>);
    };

    return(
        <LatestEpochButtonDiv>
            <TextDisplayStyle title={"Last Updated: "+lastUpdatedTime.toLocaleString()}>
                <Tooltip title="Latest Epoch" data-placement="top">
                    <RightButton/>
                </Tooltip>
                <div style={{textAlign:'center'}}>
                    <EpochValueDisplayStyle>
                        {selectedEpoch+' Z'}
                    </EpochValueDisplayStyle>
                </div>
            </TextDisplayStyle>
        </LatestEpochButtonDiv>
    );
};
